import React from 'react'

const DownloadArrowIcon = () => {
    return (
        <svg width="13" height="17" viewBox="0 0 13 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.90575 1.66666V11.8587M6.90575 11.8587L2.59375 8.10369M6.90575 11.8587L11.2178 8.10369" stroke="black" strokeWidth="1.7" strokeLinecap="round" stroke-linejoin="round" />
            <path d="M1.81055 15.6667H12.0026" stroke="black" strokeWidth="1.7" strokeLinecap="round" stroke-linejoin="round" />
        </svg>
    )
}

export default DownloadArrowIcon